import { Div } from '@kizi/core-components';
import {
  Layover,
  LayoverProps,
  Modal,
  ModalProps,
  Popover,
  PopoverProps,
} from '@kizi/shared-components';
import React from 'react';
import { MobileLayoverProps } from '.';
import { Desktop } from '../utils/breakpoint';
import { MobileLayover } from './MobileLayover';

export interface WindowProps extends MobileLayoverProps {
  children: React.ReactChild;
  layoverProps?: Omit<LayoverProps, 'children' | 'onClose' | 'show'>;
  modalProps?: Omit<ModalProps, 'onClose'>;
  popoverProps?: Omit<PopoverProps, 'children' | 'onOutsideClick'>;
  type?: 'layover' | 'modal' | 'popover';
  targetElement?: string;
  showIcon?: boolean;
}

export const Window: React.FC<WindowProps> = ({
  layoverProps,
  modalProps,
  show,
  popoverProps,
  type,
  ...restProps
}: WindowProps) => {
  let desktopComp;

  if (type === 'layover') {
    const { children, onClose } = restProps;
    desktopComp = (
      <Layover onClose={onClose} show={show} {...layoverProps}>
        {children}
      </Layover>
    );
  }

  if (type === 'modal' && modalProps) {
    const { onClose } = restProps;

    desktopComp = <Modal onClose={onClose} show={show} {...modalProps} />;
  }

  if (type === 'popover' && popoverProps) {
    const { onClose } = restProps;

    desktopComp = (
      <Popover onOutsideClick={(e) => onClose(e)} show={show} {...popoverProps}>
        <Div variant="primaryContainerPopover">{restProps['children']}</Div>
      </Popover>
    );
  }

  return show ? (
    <>
      {type && <Desktop>{desktopComp}</Desktop>}
      <MobileLayover show={show} {...restProps} />
    </>
  ) : (
    <></>
  );
};
